import { useCallback, useEffect, useState } from "react";

const KEY = "reclaim_audio_mode";

/**
 * useAudioMode — global user mode preference (Clear / Soft / Deep).
 *
 * The same chosen state travels with the user across every area of the app.
 * They don't re-choose on every screen — the last choice carries forward,
 * because their desired STATE is persistent, not the session.
 */
export default function useAudioMode() {
  const [mode, setModeState] = useState("soft");

  // Hydrate from localStorage
  useEffect(() => {
    try {
      const stored = localStorage.getItem(KEY);
      if (stored === "clear" || stored === "soft" || stored === "deep") {
        setModeState(stored);
      }
    } catch {}
  }, []);

  const setMode = useCallback((m) => {
    if (m !== "clear" && m !== "soft" && m !== "deep") return;
    setModeState(m);
    try {
      localStorage.setItem(KEY, m);
    } catch {}
  }, []);

  return [mode, setMode];
}
